import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
import { useDispatch } from 'react-redux'
import { useMutation } from '@apollo/client/react'
// hooks
import { useCurrentUser, useShowModal } from 'hooks'
// graphql
import { COMPANY_CREATE_MUTATION, COMPANY_UPDATE_MUTATION } from 'graphql/company/mutations'
// components
import Grid from '@mui/material/Grid2'
import BottomPaper from '../BottomPaper'
import SetDocumentDescriptionModal from '../../../../../../Modals/SetDocumentDescriptionModal'
// store
import { setCurrentUser } from 'store/reducers/currentUser'
// constants
import { Modals } from 'constants/modals'
// themes
import { FormInnerWrapper } from 'themes/views/settings'
// views
import { Content, EditIcon, Paper, Title } from './views'
// utils
import get from 'lodash/get'

export const DOCUMENTS = {
  LEGITIMATE: 'LEGITIMATE',
  POLICY: 'POLICY',
  CONSENT: 'CONSENT'
}

const DOCUMENTS_OPTIONS = [
  { title: 'Legitimate interest', key: DOCUMENTS.LEGITIMATE },
  { title: 'Privacy policy', key: DOCUMENTS.POLICY },
  { title: 'Consent to communicate', key: DOCUMENTS.CONSENT }
]

interface Props {
  accountForm: any
  prepareForApi: () => any
  handleCancelClick: () => void
}

const PrivacyAndConsentForm: React.FC<Props> = ({ accountForm, prepareForApi, handleCancelClick }) => {
  const user = useCurrentUser()
  const router = useRouter()
  const dispatch = useDispatch()

  const [companyCreateMutation] = useMutation(COMPANY_CREATE_MUTATION)
  const [companyUpdateMutation] = useMutation(COMPANY_UPDATE_MUTATION)

  const { showModal } = useShowModal({ modalType: Modals.SET_DOCUMENT_DESCRIPTION_MODAL })

  const handleEditClick =
    ({ key, title }) =>
    () =>
      showModal({
        width: 'sm',
        key,
        name: title,
        text: get(accountForm, `documents[${key}].description`, '')
      })

  const handleSaveCompany = async () => {
    const company = prepareForApi()

    try {
      const isUpdate = !!router.query.id

      if (isUpdate) {
        await companyUpdateMutation({
          variables: {
            id: router.query.id,
            company
          }
        })
      } else {
        await companyCreateMutation({
          variables: { company }
        })
      }

      if (company.logoUrl && router.query.id === user.companyId) {
        dispatch(setCurrentUser({ ...user, company: { ...user.company, logoUrl: company.logoUrl } }))
      }

      await router.push('/settings/accounts')
    } catch (errors) {
      console.log(errors)
    }
  }

  return (
    <>
      <FormInnerWrapper container spacing={2} direction={'column'}>
        {DOCUMENTS_OPTIONS.map(({ title, key }) => {
          const description = get(accountForm, `documents[${key}].description`, '')

          return (
            <Grid container key={key}>
              <Paper>
                <Grid container alignItems={'center'} justifyContent={'space-between'}>
                  <Grid container justifyContent={'flex-start'}>
                    <Title>{title}</Title>
                  </Grid>
                  <Grid container justifyContent={'flex-end'}>
                    <EditIcon onClick={handleEditClick({ key, title })}>Edit</EditIcon>
                  </Grid>
                </Grid>
                {description && <Content>{description}</Content>}
              </Paper>
            </Grid>
          )
        })}
      </FormInnerWrapper>
      <BottomPaper onSaveClick={handleSaveCompany} onCancelClick={handleCancelClick} />
      <SetDocumentDescriptionModal />
    </>
  )
}

export default PrivacyAndConsentForm
